import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  error: BehaviorSubject<string> = new BehaviorSubject<string>('')
  constructor() { }
  setError(error: string) {
    this.error.next(error)
  }
  getError() {
    return this.error
  }
}
